import metricsMutations from './mutationTypes'

const mutations = {
  [metricsMutations.SET_USERS] (state, { response }) {
    state.users = response.data
    state.pagination = response.headers
  },
  [metricsMutations.SET_ROLES] (state, { response }) {
    state.roles = response.data
  },
  [metricsMutations.SET_LOGIN_ERROR] (state, data) {
    state.loginDebug.push(data)
  }
}

export default {
  ...mutations
}
